import { render, staticRenderFns } from "./ProcessRecord.vue?vue&type=template&id=2f42adec&scoped=true"
import script from "./ProcessRecord.vue?vue&type=script&lang=js"
export * from "./ProcessRecord.vue?vue&type=script&lang=js"
import style0 from "./ProcessRecord.vue?vue&type=style&index=0&id=2f42adec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f42adec",
  null
  
)

export default component.exports